import type { ReactNode } from 'react';

export const symbol_foundation: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M261-286v136q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-136h-53q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h53v-206L99-475q-10.04 8-21.52 6.5T58-480q-8-10-6-22t12-20l380-290q8-6 17-9.5t19-3.5q10 0 19 3.5t17 9.5l380 290q10 8 11.5 20t-6.5 22q-8 10-19.48 11.5T860-475l-102-78v207h53q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-53v136q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-136H510v136q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-136H261Zm0-60h189v-396L261-598v252Zm249 0h188v-252L510-742v396Z"
		/>
	</svg>
);
